import React from 'react';
import { Link as ReactRouterLink, hashHistory } from 'react-router'
import { get, pick, isObject } from 'lodash';

const QUERY_PARAMS_TO_PRESERVE = ['lang'];

export const Link = ({ children, to, target }) => {
  const currentLocation = hashHistory.getCurrentLocation();
  const currentQuery = get(currentLocation, 'query', {});
  const nextQuery = pick(currentQuery, QUERY_PARAMS_TO_PRESERVE);

  const pathname = isObject(to) ? get(to, 'pathname', '/') : to;
  const query = isObject(to) ? { ...get(to, 'query', {}), ...nextQuery } : nextQuery;

  return (
    <ReactRouterLink
      to={{
        pathname,
        query,
      }}
      target={target || '_self'}
    >
      {children}
    </ReactRouterLink>
  )
};


// WEBPACK FOOTER //
// ./src/views/visions/vx-link.js